import * as t from 'ts-schema';
import * as Category from 'marketplace-ui-common/constants/groupTags/Category';
export const appSearchResponseItemSchema = t.object({
  category: t.union(...Object.values(Category).map(value => t.literal(value))),
  companyName: t.string,
  firstPublishedAt: t.number,
  iconUrl: t.string,
  id: t.number,
  installed: t.boolean,
  installsCount: t.number,
  language: t.string,
  name: t.string,
  offeringId: t.number,
  recommended: t.boolean,
  slug: t.string,
  sourceId: t.string,
  tagline: t.string
});